import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import SaveIcon from "@material-ui/icons/Save";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DeleteIcon from "@material-ui/icons/Delete";
import TextField from "@material-ui/core/TextField";
import { green, orange, red, grey } from "@material-ui/core/colors";
import PropTypes from "prop-types";

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const RoomRatesEditor = (props) => {
    const [newPrice, setNewPrice] = useState(null);

    const keyDownHandler = (e) => {
        if (e.key === "Enter" && newPrice > 0) {
            props.onSubmit(newPrice, props.pickedCells);
        } else if (e.key === "Escape") {
            props.onClose();
        }
    };

    return (
        <div>
            <Dialog
                onKeyDown={keyDownHandler}
                open={props.isVisible}
                onClose={props.onClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle
                    style={{ cursor: "move" }}
                    id="draggable-dialog-title"
                >
                    Введите новую стоимость
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        error={newPrice < 0}
                        helperText={
                            newPrice < 0
                                ? "Значение не может быть отрицательным"
                                : null
                        }
                        id="standard-number"
                        label="Стоимость"
                        type="number"
                        onChange={(e) => setNewPrice(parseInt(e.target.value))}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={props.onClose}
                        color="primary"
                        variant="contained"
                        endIcon={<ArrowBackIcon />}
                        style={{ backgroundColor: orange[500] }}
                    >
                        Вернуться
                    </Button>

                    <Button
                        disabled={newPrice > 0 ? false : true}
                        onClick={() =>
                            props.onSubmit(newPrice, props.pickedCells)
                        }
                        color="primary"
                        variant="contained"
                        endIcon={<SaveIcon />}
                        style={
                            newPrice > 0
                                ? { backgroundColor: green[500] }
                                : { backgroundColor: grey[500] }
                        }
                    >
                        Сохранить
                    </Button>
                    <Button
                        onClick={() => props.onSubmit(0, props.pickedCells)}
                        color="primary"
                        variant="contained"
                        endIcon={<DeleteIcon />}
                        style={{ backgroundColor: red[500] }}
                    >
                        Удалить стоимость
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

RoomRatesEditor.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    pickedCells: PropTypes.array,
};

export default RoomRatesEditor;
